export default {
  emailConfig: {},
  smsConfig: {},
  webHookConfig: {},
  toggleLoad: false,
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/tracking-config/store/states.js